import store from "@/store";
import EndGameVideo from '@/components/views/EndGameVideo';
import EnzoFiring from '@/components/views/EnzoFiring';

export default [
	{
		path: '/ending/win',
		component: EndGameVideo,
		props: () => ({
			video: store.state.global.api.data.config.videos.ending.win.url,
		}),
	},
	{
		path: '/ending/lose',
		component: EndGameVideo,
		props: () => ({
			video: store.state.global.api.data.config.videos.ending.lose.url,
		}),
	},
	{
		path: '/ending/fired',
		component: EnzoFiring,
		props: () => {
			const score = store.getters["game/scores/zeroScore"];
			return store.state.global.api.data.ui.fired.scores[score.id];
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/ending.routes.js